import React, {Component} from "react";
import PropTypes from "prop-types";
import FocusTrap from "focus-trap-react";

export default class Modal extends Component {
    static boolToDisplay(visible) {
        return visible ? 'block' : 'none'
    }

    static boolToVisibility(visible) {
        return visible ? 'visible' : 'hidden';
    }

    static boolToOpacity(visible) {
        return visible ? 1 : 0;
    }

    render() {
        return (
            <FocusTrap active={this.props.visible}>
                <div className="modal-shadow" style={{
                    visibility: Modal.boolToVisibility(this.props.visible),
                    opacity: Modal.boolToOpacity(this.props.visible)
                }}>
                    <div className="modal" tabIndex="-1" role="dialog"
                         style={{display: Modal.boolToDisplay(this.props.visible)}}>
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Modal title</h5>
                                    <button onClick={this.props.toggleCallback} type="button" className="close"
                                            aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <input/>
                                    <p>Modal body text goes here.</p>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-primary">Speichern</button>
                                    <button onClick={this.props.toggleCallback} type="button"
                                            className="btn btn-secondary">Schließen
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </FocusTrap>
        )
    }
}

Modal.propTypes = {
    visible: PropTypes.bool,
    toggleCallback: PropTypes.func
};


// WEBPACK FOOTER //
// ./src/components/Modal.js